import { veeFormFieldHOC } from '@/kasten-components/components/KaVeeFormField';

import { default as KaCheckbox } from './KaCheckbox.vue';

export { type KaCheckboxProps } from './KaCheckbox.vue';

export const KaCheckboxVee = veeFormFieldHOC(KaCheckbox, {
  KaVeeForm: { checkbox: true },
});

export { KaCheckbox };
